import { css, Theme } from '@emotion/react'
import { scaleBorderRadius } from 'theme/utils'

export const container = (theme: Theme) => css`
  width: 100%;
  padding: ${theme.spacing(3)};
`

export const headerWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;

  span {
    font-weight: 700;
  }
`

export const link = (theme: Theme) => css`
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};

  color: ${theme.colors.blueHover};
`

export const tablesWrapper = css`
  margin-top: 24px;
  display: flex;
  gap: 15px;
  align-items: flex-start;
`

export const tableHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`

export const tableTitle = css`
  font-weight: 600;
`

export const titleCell = (theme: Theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(3)};

  cursor: default;
`

const previewDimensions = css`
  width: 90px;
  height: 50px;
`

export const videoPlayerWrapper = css`
  ${previewDimensions};
  flex-shrink: 0;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const noPreview = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  ${previewDimensions};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2)};

  background-color: ${theme.colors.backgroundFive};
`

export const categoriesWrapper = css`
  flex: 1;
`

export const categoriesTable = css`
  .table-header .table-cell {
    font-weight: 700;
  }

  .table-row {
    padding: 5px 12px;
  }
`

export const videosWrapper = (theme: Theme) => css`
  flex: 1;
  border-radius: 20px;
  background: ${theme.backgrounds.backgroundFive};
  padding: 14px;
`

export const addVideoButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.5)};
  width: 100%;
`

export const videoCategoryTable = (theme: Theme) => css`
  .table-header {
    background: ${theme.backgrounds.backgroundFive};

    .table-cell {
      font-weight: 700;
    }
  }

  .table-row {
    padding: 5px 12px;
    padding-right: ${theme.spacing(0.75)};
  }
`

export const videosTable = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.5)};

  .table-header {
    background: ${theme.colors.white};
  }
`
